import { axiosInstance as axios } from 'Api';
import React from 'react';
import loadable from '@loadable/component';
import itAppStrings from 'Translations/lang-it.json';
import moment from 'moment';
import { Config } from 'Constants/config_env';
const { createHash } = require('crypto');

/** @function
 * * Handling the API Rest resposnse, and return data and different message for status code
 * @name handlingResponse
 * @param {object} data - The response of method
 * @return {object} - The response of method, with additional info
 */
export const handlingResponse = (data) => {
	if (data.status >= 200 && data.status < 400) {
    return { response: data };
  } else {
		switch (data.status) {
			case 400:
				data.type = 'Bad Request';
				break;
			case 401:
				data.type = 'Unauthorized';
				break;
			case 403:
				data.type = 'Forbidden';
				break;
			case 404:
				data.type = 'Not Found';
				break;
			case 500:
				data.type = 'ServerError';
				break;
			default:
				data.type = 'Invalid Data';
				break;
		}
		return { error: data };
	}
};

/**  @function
 * * Handling the null case and set to safe
 *
 * @name nullSafe
 * @param {function} func
 * @param {*} fallbackValue
 * @returns {*} the value to set safe the method
 */
export const nullSafe = (func, fallbackValue) => {
	try {
		const value = func();
		return value === null || value === undefined ? fallbackValue : value;
	} catch (e) {
		return fallbackValue;
	}
};

/**  @function
 * * Handling the language file from the CMS
 *
 * @name getLang
 * @returns {objet} the object list of messages
 */
export const getLang = async () => {
	let LANGUAGEURL = Config.language_url;
	let response;
	let lang;
	try {
		response = await axios({
			url: LANGUAGEURL,
		});
	} catch (error) {
		console.log(error);
	}
	if (response && typeof response.data === 'object') {
		lang = response.data;
	} else {
		lang = {
			data: {
				messages: {
					it: {
						...itAppStrings,
					},
				},
				locale: window.navigator.language.substring(0, 2),
			},
		};
	}
	return lang;
};

/**  @function
 * * Handling the null case and set to safe
 *
 * @name retrieveEnv
 * @returns {object} the object contains all env params
 */
export const retrieveEnv = async () => {
	let response;
	try {
		response = await axios({
			url: ``,
		});
	} catch (error) {
		console.error(error);
	}
	return response;
};

/**  @function
 * * Import a component with loadable library
 *
 * @name loadable
 * @returns {$Symbols} the required component
 */
export const loadableComponent = (component) =>
  loadable(() => import(
    /* webpackChunkName: "[request]" */
    /* webpackExclude: /\.test\.(js|jsx)$/ */
    `Components/${component}`), {
    fallback: <div> Loading... </div>
  });

/**  @function
 * * Import a page with loadable library
 *
 * @name loadable
 * @returns {$Symbols} the required library
 */
export const LoadablePage = loadable(
  (props) => import(
    /* webpackChunkName: "[request]" */
    /* webpackExclude: /\.test\.(js|jsx)$/ */
    `Route/${props.page}/components/${props.page}Container`), {
    cacheKey: (props) => props.page
  });

export const LoadableSubPage = loadable(
  (props) => import(
    /* webpackChunkName: "[request]" */
    /* webpackExclude: /\.test\.(js|jsx)$/ */
    `Route/${props.father ? `${props.father}/` : ''}components/${props.page}/${props.page}Container`), {
    cacheKey: (props) => props.page
  });

export const resetReduxState = (draft, initialState) => {
	const listOfInitialStateKeys = Object.keys(initialState);
	if (listOfInitialStateKeys.length > 0) {
		listOfInitialStateKeys.forEach((element) => {
			draft[element] = initialState[element];
		});
	}
};

export const generateFormikTest = (testName, errorMessage, testFunction) => ({
	name: `${testName}Validation`,
	message: errorMessage,
	test: testFunction,
});

export const isUndefined = (val) => val === undefined;

export const isValidDate = (val, inputDateFormat = 'DD-MM-YYYY') =>
	moment(val && val.length > 10 ? val.slice(0, 10) : val, inputDateFormat, true).isValid();

/**  @function
 * * Retrieve the desired value, from an object
 *
 * @name getNestedObject
 * @param {object} nestedObj
 * @param {array} pathArr
 * @returns {*} the value from the chhosed key
 */

export const getNestedObject = (nestedObj, pathArr) =>
	pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), nestedObj);

export const formatListRequest = (groupId, pageNumber, pageSize) => ({
	groupId: groupId,
	pageNumber: pageNumber,
	size: pageSize,
});

export async function validateJWT() {
	let data;

	try {
		data = await axios({
			method: 'post',
			url: `${Config.logger_server}/validateToken`,
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export const randomHash = (format, length) => {
  let pool = "";

  switch (format) {
    case "alnum":
      pool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      break;
    case "alpSpecLower":
      pool = "abcdefghijklmnopqrstuvwxyz-_";
      break;
    case "alpha":
      pool = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      break;
    case "alpNumLower":
      pool = "0123456789abcdefghijklmnopqrstuvwxyz";
      break;
    case "hexdec":
      pool = "0123456789abcdef";
      break;
    case "numeric":
      pool = "0123456789";
      break;
    case "nozero":
      pool = "123456789";
      break;
    default:
      return "";
  }

  let buf = "";

  for (let i = 0; i < length; i++) {
    buf += pool.charAt(Math.floor(Math.random() * pool.length));
  }

  return buf;
}

export const createReqId = () => {
  const hash = createHash('md5');
  hash.update(randomHash('alnum', 30))
  const reqId = hash.digest('hex')
  return reqId + randomHash('alnum', 4)
}

export const generateSessId = () => {
  const hash = createHash('md5');
  window.sessionStorage.setItem('sessionId', hash.digest('hex'));
}
